import React, { useState } from 'react';
import classNames from 'classnames';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import GridContainer from '@/components/material-ui-kit/components/Grid/GridContainer.js';
import GridItem from '@/components/material-ui-kit/components/Grid/GridItem.js';

import styles from 'styles/jss/original/components/common/ui/navPillsStyle';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  // index of the default active pill
  active?: number;
  tabs: {
    tabButton: string;
    tabIcon?: Todo;
    tabContent: React.ReactNode;
  }[];
  color?: 'primary' | 'warning' | 'danger' | 'success' | 'info' | 'rose';
  direction?: string;
  horizontal?: {
    tabsGrid: Todo;
    contentGrid: Todo;
  };
  alignCenter?: boolean;
  isShopping?: boolean;
};

const NavPills: React.FC<ComponentProps> = (props) => {
  const [active, setActive] = useState(0);
  const handleChange = (_event: React.ChangeEvent<Todo>, active: number) => {
    setActive(active);
  };
  const handleChangeIndex = (index: number) => {
    setActive(index);
  };
  const {
    tabs,
    direction = 'rtl',
    color = 'primary',
    horizontal,
    alignCenter = false,
    isShopping = false
  } = props;
  const classes = useStyles();
  const flexContainerClasses = classNames({
    [classes.flexContainer]: true,
    [classes.horizontalDisplay]: horizontal !== undefined
  });
  const tabButtons = (
    <Tabs
      classes={{
        root: isShopping ? classes.rootShopping : classes.root,
        fixed: isShopping ? classes.fixedShopping : classes.fixed,
        flexContainer: flexContainerClasses,
        indicator: classes.displayNone
      }}
      value={active}
      onChange={handleChange}
      centered={alignCenter}
    >
      {tabs.map((prop, key) => {
        const icon: Todo = {};
        if (prop.tabIcon !== undefined) {
          icon['icon'] = <prop.tabIcon className={classes.tabIcon} />;
        }
        const pillsClasses = classNames({
          [classes.pills]: true,
          [classes.horizontalPills]: horizontal !== undefined,
          [classes.pillsWithIcons]: prop.tabIcon !== undefined
        });
        return (
          <Tab
            label={prop.tabButton}
            key={key}
            {...icon}
            classes={{
              root: pillsClasses,
              // @ts-expect-error
              label: classes.label,
              selected: classes[color]
            }}
          />
        );
      })}
    </Tabs>
  );
  const tabContent = (
    <div className={classes.contentWrapper}>
      <SwipeableViews
        axis={direction === 'rtl' ? 'x-reverse' : 'x'}
        index={active}
        onChangeIndex={handleChangeIndex}
      >
        {tabs.map((prop, key) => {
          return (
            // @ts-expect-error
            <div className={classes.tabContent} key={key}>
              {prop.tabContent}
            </div>
          );
        })}
      </SwipeableViews>
    </div>
  );
  return horizontal !== undefined ? (
    <GridContainer>
      <GridItem {...horizontal.tabsGrid}>{tabButtons}</GridItem>
      <GridItem {...horizontal.contentGrid}>{tabContent}</GridItem>
    </GridContainer>
  ) : (
    <div>
      {tabButtons}
      {tabContent}
    </div>
  );
};

export default NavPills;
